import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'ng-sidebar-container',
    template: `<ng-content></ng-content>`,
    styles: [`
    :host {
      display: block;
      position: relative;
      min-height: 100vh;
    }
  `],
    standalone: false
})
export class SidebarContainerComponent {}

@Component({
    selector: 'ng-sidebar',
    template: `
    <div
      class="sidebar-backdrop"
      *ngIf="opened && showBackdrop"
      (click)="onBackdropClick()"
    ></div>
    <div
      class="sidebar-panel"
      [class.sidebar-open]="opened"
      [class.sidebar-right]="position === 'right'"
      [class.sidebar-left]="position !== 'right'"
    >
      <ng-content></ng-content>
    </div>
  `,
    styles: [`
    .sidebar-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 3;
    }

    .sidebar-panel {
      position: fixed;
      top: 0;
      height: 100%;
      width: 70%;
      max-width: 950px;
      background: var(--bs-light, #f8f9fa);
      box-shadow: 0 0 10px rgba(200, 200, 200, 0.15);
      z-index: 3;
      overflow-y: auto;
      overflow-x: hidden;
      transition: transform 0.3s ease-in-out;
    }

    .sidebar-right {
      right: 0;
      transform: translateX(100%);
    }

    .sidebar-right.sidebar-open {
      transform: translateX(0);
    }

    .sidebar-left {
      left: 0;
      transform: translateX(-100%);
    }

    .sidebar-left.sidebar-open {
      transform: translateX(0);
    }
  `],
    standalone: false
})
export class SidebarComponent implements OnChanges {
  @Input() opened: boolean = false;
  @Output() openedChange = new EventEmitter<boolean>();

  @Input() position: 'left' | 'right' = 'left';
  @Input() showBackdrop: boolean = true;
  @Input() closeOnClickOutside: boolean = true;
  @Input() closeOnClickBackdrop: boolean = true;
  @Input() mode: 'over' | 'push' = 'over';

  @Output() onClosed = new EventEmitter<void>();

  ngOnChanges(_changes: SimpleChanges): void {
    // Handle external changes to opened
  }

  onBackdropClick(): void {
    if (this.closeOnClickBackdrop) {
      this.opened = false;
      this.openedChange.emit(false);
      this.onClosed.emit();
    }
  }
}
